document.addEventListener("DOMContentLoaded", () => {

  const compareButtons = document.querySelectorAll(".compare-trigger");

  const compareBar = document.querySelector(".compare-bar");
  const compareItems = document.querySelector(".compare-items");
  const compareCount = document.querySelector(".compare-count");
  const compareModal = document.querySelector(".compare-modal");
  const compareGrid = document.querySelector(".compare-grid");

  let compareProducts =
    JSON.parse(localStorage.getItem("compareProducts")) || [];

  /* SAVE */

  function saveCompare() {
    localStorage.setItem(
      "compareProducts",
      JSON.stringify(compareProducts)
    );
  }

  /* RENDER BAR */

  function renderCompareBar() {

    compareItems.innerHTML = "";

    if (compareProducts.length === 0) {
      compareBar.style.display = "none";
      return;
    }

    compareBar.style.display = "flex";

    compareCount.innerHTML =
      `${compareProducts.length} Products Selected`;

    compareProducts.forEach((product, index) => {

      compareItems.innerHTML += `
        <div class="compare-thumb">

          <img src="${product.image}" alt="${product.title}">

          <button class="compare-remove" data-index="${index}">
            ×
          </button>

        </div>
      `;

    });

  }

  /* RENDER MODAL */

  function renderCompareModal() {

    compareGrid.innerHTML = `

      <div class="compare-table">

        <!-- PRODUCT IMAGE -->

        <div class="compare-row">

          <div class="compare-field">
            Product
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <div class="compare-product-image">

                <img src="${product.image}" alt="${product.title}">

              </div>

            </div>

          `).join('')}

        </div>

        <!-- PRODUCT NAME -->

        <div class="compare-row">

          <div class="compare-field">
            Product Name
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <div class="compare-title">

                ${product.title}

              </div>

            </div>

          `).join('')}

        </div>

        <!-- SELLING PRICE -->

        <div class="compare-row">

          <div class="compare-field">
            Selling Price
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <span class="compare-sale-price">

                ${product.price}

              </span>

            </div>

          `).join('')}

        </div>

        <!-- ACTUAL PRICE -->

        <div class="compare-row">

          <div class="compare-field">
            Actual Price
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <span class="compare-old-price">

                ${product.compare || '--'}

              </span>

            </div>

          `).join('')}

        </div>

        <!-- DISCOUNT -->

        <div class="compare-row">

          <div class="compare-field">
            Discount
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <span class="compare-discount">

                ${product.discount || '--'}

              </span>

            </div>

          `).join('')}

        </div>

        <!-- BRAND -->

        <div class="compare-row">

          <div class="compare-field">
            Brand
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              ${product.vendor || '--'}

            </div>

          `).join('')}

        </div>

        <!-- SIZE -->

        <div class="compare-row">

          <div class="compare-field">
            Sizes Available
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              ${product.sizes || 'Free Size'}

            </div>

          `).join('')}

        </div>

        <!-- STOCK -->

        <div class="compare-row compare-row-availability">

          <div class="compare-field">
            Availability
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <span class="available">
                In Stock
              </span>

            </div>

          `).join('')}

        </div>

        <!-- ACTIONS -->

        <div class="compare-row">

          <div class="compare-field">
            Actions
          </div>

          ${compareProducts.map(product => `

            <div class="compare-value">

              <div class="compare-actions">

                <a href="${product.url}" class="compare-view-btn">

                  View Product

                </a>

              </div>

            </div>

          `).join('')}

        </div>

      </div>

    `;

  }

  /* ADD PRODUCT */

  compareButtons.forEach(button => {

    button.addEventListener("click", () => {

      const product = {

        title: button.dataset.title,
        price: button.dataset.price,
        compare: button.dataset.compare,
        image: button.dataset.image,
        url: button.dataset.url,
        description: button.dataset.description,
        category: button.dataset.category,
        vendor: button.dataset.vendor,
        sizes: button.dataset.sizes,
        discount: button.dataset.discount

      };

      const exists = compareProducts.find(
        item => item.title === product.title
      );

      if (exists) {
        return;
      }
           
      if (compareProducts.length >= 5) {

        alert("Maximum 5 products allowed");

        return;

      }
     
      compareProducts.push(product);

      saveCompare();

      renderCompareBar();

    });

  });

  /* REMOVE PRODUCT */

  document.addEventListener("click", (e) => {

    if (e.target.classList.contains("compare-remove")) {

      const index = e.target.dataset.index;

      compareProducts.splice(index, 1);

      saveCompare();

      renderCompareBar();

      renderCompareModal();

    }

  });

  /* OPEN MODAL */

  document.querySelector(".compare-open")
    .addEventListener("click", () => {

      compareModal.classList.add("active");

      renderCompareModal();

    });

  /* CLOSE MODAL */

  document.querySelector(".compare-close")
    .addEventListener("click", () => {

      compareModal.classList.remove("active");

    });

  document.querySelector(".compare-modal-overlay")
    .addEventListener("click", () => {

      compareModal.classList.remove("active");

    });

  /* CLEAR */

  document.querySelector(".compare-clear")
    .addEventListener("click", () => {

      compareProducts = [];

      saveCompare();

      renderCompareBar();

      compareModal.classList.remove("active");

    });

  /* INIT */

  renderCompareBar();

});